import React, { Component } from 'react';
import { Container, Title } from 'common/components/Layout/Layout';
import ContentStore from 'stores/Content.store';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import ContactForm from './components/ContactForm';
import VideoSection from 'common/components/VideoSection/VideoSection';

import Placeholder from 'common/components/Placeholder/Placeholder';
import ImageGreyBackground from 'common/components/ImageGreyBackground/ImageGreyBackground';
import FullWidthBackground from 'common/components/Placeholder/components/FullWidthBackground/FullWidthBackground';
import Document from 'common/components/Document/Document';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';
import Modal from 'common/components/Modal/Modal.js';
import styles from './IssueOfSharesView.module.scss';

@injectIntl
@observer
export default class IssueOfSharesView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: true
    };
  }

  toggleModal = () => {
    this.setState(prevState => ({ isModalOpen: !prevState.isModalOpen }));
  };

  render() {
    const content = ContentStore.content.IssueOfShares;
    return (
      <div className={styles.IssueOfShares}>
        {ContentStore.isLoaded && <InjectMetaTags {...content.seo} />}
        <Container>
          <Title title={content.title} />
        </Container>
        <Placeholder component={<FullWidthBackground />} ready={!!content}>
          {content && (
            <ImageGreyBackground
              className={styles.BoldHeading}
              source={content.photo.url}
              alternative="hello"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: content.description
                }}
              />
            </ImageGreyBackground>
          )}
        </Placeholder>
        {content.videoUrl && (
          <Container>
            <div className={styles.IssueOfSharesContent}>
              <p>{content.videoHeader}</p>
              <VideoSection videoUrl={content.videoUrl} />
            </div>
          </Container>
        )}
        {content.attachments && (
          <Container>
            <div className={styles.IssueOfSharesContent}>
              <p>{content.filesHeader}</p>
              {content.attachments.map(item => (
                <Document key={item.system.id} document={item} />
              ))}
            </div>
          </Container>
        )}
        <Container>
          <div className={styles.ContactFormContainer}>
            <ContactForm />
          </div>
        </Container>
        <Modal isOpen={this.state.isModalOpen} onClose={this.toggleModal}>
          {content.modalContent}
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/IssueOfShares/IssueOfSharesView.js